import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;
console.log("sub key xxx", SUBSCRIPTION_KEY)

const getDistictProducts = () => {
    let parameters = null
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_PRODUCT_LIST, parameters, subscriptionKey);
    return result;
}

const getUserTypes = () => {
    let parameters = null
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_USER_TYPES, parameters, subscriptionKey);
    return result;
}

const getCountry = () => {
    let parameters = null
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_COUNTRY, parameters, subscriptionKey);
    return result;
}

const getRegion = (country) => {
    let query_param = {
        country: country
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_REGION, query_param, subscriptionKey);
    return result;
}

const getProvince = (country, region) => {
    let query_param = {
        country: country,
        region: region
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_PROVINCE, query_param, subscriptionKey);
    return result;
}

const getCityMunicipality = (country, region, province) => {
    let query_param = {
        country: country,
        region: region,
        province: province
    }
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_CITY_MUNICIPALITY, query_param, subscriptionKey);
    return result;
}

const getUserEmail = () => {
    let parameters = null
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_USER_EMAIL, parameters, subscriptionKey);
    return result;
}

const getModule = () => {
    let parameters = null
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_MODULE, parameters, subscriptionKey);
    return result;
}

const getDistinctFraudType = () => {
    let query_params = null;
    let subscriptionKey = SUBSCRIPTION_KEY;

    let result = HttpGet(routes.GET_FRAUD_TYPE, query_params, subscriptionKey);
    return result;
}


const FilterService = {
    getDistictProducts: getDistictProducts,
    getUserTypes: getUserTypes,
    getCountry: getCountry,
    getRegion: getRegion,
    getProvince: getProvince,
    getCityMunicipality: getCityMunicipality,
    getUserEmail: getUserEmail,
    getModule: getModule,
    getDistinctFraudType: getDistinctFraudType,
}

export default FilterService
